export default __webpack_public_path__ + "static/media/HVAC-System-Work-CoyneCollege-Chicago-1536x1024.d7807ef3.jpeg";